export default __webpack_public_path__ + "static/media/1516 cutlery top.0216fabc.png";